import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { InstanceLocation } from '../../../models/entity-models/instance-location.model';
import { APP_CONFIG, AppConfig } from '../../config/app-config';
import { Instance } from '../../base/entities/transport.interface';
import { AssignInstanceResponse } from '../../base/entities/assign-instance-response';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {
  constructor(@Inject(APP_CONFIG) private readonly appConfig: AppConfig, private readonly http: HttpClient) {}

  getInstanceByObjectId(opcoCode: string, objectId: string) {
    const params = new HttpParams().set('opcoCode', opcoCode).set('objectId', objectId);
    return this.http.get<Instance>(`${this.appConfig.newApiUrl}api/GetInstance`,  { params });
  }

  getInstanceByTransportId(transportId: string) {
    return this.http.get<Instance>(`${this.appConfig.newApiUrl}api/transports/${transportId}/instance`);
  }

  getLocation(transportId: string) {
    return this.http.get<InstanceLocation>(
      `${this.appConfig.newApiUrl}api/transports/${transportId}/instance/GetTrackAndTraceInfo`
    );
  }

  assignInstance(transportId: string, newInstanceId: string, noAutoSwap: boolean) {
    return this.http.post<AssignInstanceResponse>(`${this.appConfig.newApiUrl}api/AssignInstance`, {
      transportId,
      newInstanceId,
      noAutoSwap
    });
  }
}
